// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recent-games {
  color: #343437;
  overflow: hidden;
}
.recent-games .button-container {
  padding: 4px;
  border-radius: 10px;
  max-width: 95%;
  margin-left: 2.5%;
  display: flex;
  flex-direction: row;
  background-color: #D7E7F3;
}
.recent-games .button-container .segment-button {
  border-radius: 8px;
  width: 50%;
  background-color: #D7E7F3;
  height: 100%;
  min-height: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}
.recent-games .button-container .segment-button ion-label {
  align-self: center;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.recent-games .button-container .segment-button.selected {
  background-color: var(--ion-color-secondary);
}
.recent-games .button-container .segment-button.selected ion-label {
  color: #fff;
}
.recent-games .content-container {
  min-height: 8.2rem;
}
.recent-games .content-container .no-games-card-container {
  display: flex;
  padding-top: -50px;
  max-width: 80%;
  margin-left: 10%;
  padding: 0%;
  justify-content: center;
  overflow: hidden;
}
.recent-games .content-container .no-games-card-container .no-games-card {
  color: var(--ion-color-secondary);
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.recent-games .content-container .no-games-card-container .no-games-card .title {
  font-weight: bold;
  text-align: center;
}
.recent-games .content-container .no-games-card-container .no-games-card .subtitle {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
}
.recent-games .content-container .mobile-games-gallery {
  display: flex;
  flex-direction: row;
  padding-top: 0.8rem;
  overflow-x: scroll;
  overflow-y: hidden;
  color: var(--ion-color-secondary);
}
.recent-games .content-container .mobile-games-gallery::-webkit-scrollbar {
  display: none;
}
.recent-games .content-container .mobile-games-gallery .mobile-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 10px 0px 10px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container {
  min-width: 18%;
  height: 80px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .image-tile {
  min-width: 75px;
  min-height: 75px;
  border: solid 1px black;
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .close-button {
  position: relative;
  top: -80px;
  right: -54px;
  border: solid 1px var(--ion-color-secondary);
  border-radius: 50%;
  background-color: var(--ion-color-secondary);
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .hidden-button {
  position: relative;
  top: -72px;
  right: -54px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .game-label {
  color: var(--ion-color-secondary);
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin: 0%;
  padding: 0%;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .text-label {
  font-size: 0.7rem;
  margin: 0%;
  padding: 0%;
}

ion-content {
  --background: black no-repeat 100% 100%;
}

.jackpot-mobile-top {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.jackpot-mobile-bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

jackpot-counter-mobile {
  position: absolute;
  z-index: 998;
  background: var(--ion-color-secondary);
  color: #FFFFFF;
  font-weight: bold;
  padding: 3px 0px;
  left: 0;
  text-align: center;
  width: 100%;
  font-family: var(--font-primary);
}

ion-icon {
  font-size: 1.5rem;
}

.jackpot-counter-top {
  top: 0;
}

.jackpot-counter-bottom {
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/games/games.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACJ;AAEI;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,qCAAA;EACA,gBAAA;AAAN;AAEM;EACE,kBAAA;EACA,iCAAA;EACA,eAAA;AAAR;AAGM;EACE,4CAAA;AADR;AAGQ;EACE,WAAA;AADV;AASE;EACE,kBAAA;AAPJ;AASI;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAPN;AASM;EACE,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAPR;AASQ;EACE,iBAAA;EACA,kBAAA;AAPV;AAUQ;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AARV;AAaI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;AAXN;AAaM;EACE,aAAA;AAXR;AAcM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAZR;AAcQ;EACE,cAAA;EACA,YAAA;AAZV;AAcU;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAZZ;AAeU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,4CAAA;AAbZ;AAgBU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAdZ;AAkBQ;EACE,iCAAA;EACA,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;AAhBV;AAmBQ;EACE,iBAAA;EAEA,UAAA;EACA,WAAA;AAlBV;;AA6BA;EACE,uCAAA;AA1BF;;AA8BA;EACE,4BAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,+BAAA;EACA,8BAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AA3BF;;AA8BA;EACE,iBAAA;AA3BF;;AA8BA;EACE,MAAA;AA3BF;;AA8BA;EACE,SAAA;AA3BF","sourcesContent":[".recent-games {\n  color: #343437;\n  overflow: hidden;\n\n  .button-container {\n    padding: 4px;\n    border-radius: 10px;\n    max-width: 95%;\n    margin-left: 2.5%;\n    display: flex;\n    flex-direction: row;\n    background-color: #D7E7F3;\n\n\n    .segment-button {\n      border-radius: 8px;\n      width: 50%;\n      background-color: #D7E7F3;\n      height: 100%;\n      min-height: 2rem;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      font-family: 'Montserrat', sans-serif;\n      font-weight: 500;\n\n      ion-label {\n        align-self: center;\n        color: var(--ion-color-secondary);\n        font-size: 14px;\n      }\n\n      &.selected {\n        background-color: var(--ion-color-secondary);\n\n        ion-label {\n          color: #fff;\n        }\n      }\n    }\n\n\n  }\n\n  .content-container {\n    min-height: 8.2rem;\n\n    .no-games-card-container {\n      display: flex;\n      padding-top: -50px;\n      max-width: 80%;\n      margin-left: 10%;\n      padding: 0%;\n      justify-content: center;\n      overflow: hidden;\n\n      .no-games-card {\n        color: var(--ion-color-secondary);\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n\n        .title {\n          font-weight: bold;\n          text-align: center;\n        }\n\n        .subtitle {\n          font-weight: bold;\n          text-align: center;\n          font-size: 14px;\n        }\n      }\n    }\n\n    .mobile-games-gallery {\n      display: flex;\n      flex-direction: row;\n      padding-top: 0.8rem;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      color: var(--ion-color-secondary);\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .mobile-block {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 5px 10px 0px 10px;\n\n        .image-container {\n          min-width: 18%;\n          height: 80px;\n\n          .image-tile {\n            min-width: 75px;\n            min-height: 75px;\n            border: solid 1px black;\n            border-radius: 10px;\n            background-size: cover;\n            background-repeat: no-repeat;\n            background-position: center;\n            position: relative;\n          }\n\n          .close-button {\n            position: relative;\n            top: -80px;\n            right: -54px;\n            border: solid 1px var(--ion-color-secondary);\n            border-radius: 50%;\n            background-color: var(--ion-color-secondary);\n          }\n\n          .hidden-button {\n            position: relative;\n            top: -72px;\n            right: -54px;\n          }\n        }\n\n        .game-label {\n          color: var(--ion-color-secondary);\n          display: flex;\n          justify-content: flex-start;\n          align-items: flex-end;\n          margin: 0%;\n          padding: 0%;\n        }\n\n        .text-label {\n          font-size: 0.7rem;\n\n          margin: 0%;\n          padding: 0%;\n        }\n      }\n    }\n  }\n}\n\n.background-fixer {\n  // background-color: #161721;\n}\n\nion-content {\n  --background: black no-repeat 100% 100%;\n}\n\n\n.jackpot-mobile-top {\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n\n.jackpot-mobile-bottom {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\njackpot-counter-mobile {\n  position: absolute;\n  z-index: 998;\n  background: var(--ion-color-secondary);\n  color: #FFFFFF;\n  font-weight: bold;\n  padding: 3px 0px;\n  left: 0;\n  text-align: center;\n  width: 100%;\n  font-family: var(--font-primary);\n}\n\nion-icon {\n  font-size: 1.5rem;\n}\n\n.jackpot-counter-top {\n  top: 0;\n}\n\n.jackpot-counter-bottom {\n  bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
